import { init } from '@rematch/core';

const models = require(`./models/${window.$environment.SERVICE_PROVIDER}`);

const store = init({
  models: { ...models },
  redux: {
    rootReducers: { RESET_APP: () => undefined },
    devtoolOptions: {
      name: 'Rematch Store', // Name shown in Redux DevTools
      trace: true, // Enable tracing for debugging
      traceLimit: 25, // Limit the stack trace frames
    },
  },
});

export default store;
